document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".play-button").forEach(function (playButton) {
    playButton.addEventListener("click", function () {
      const videoSrc = playButton.getAttribute("data-src")

      const modal = document.querySelector('.c-modal')
      const modalClose = modal.querySelector('.js-modal__close')
      const modalVideo = modal.querySelector('video')
      const modalSource = modalVideo.querySelector('source')

      if (videoSrc && modal && modalClose && modalVideo && modalSource) {
        modalSource.src = videoSrc
        modalVideo.load()
        modalVideo.play()
        modal.style.display = 'block'

        modalClose.addEventListener("click", function () {
          modal.style.display = 'none'
          modalVideo.pause()
          modalSource.src = ''
        });
      }
    });
  });
});
